import { useRef, useState } from 'react';
import { useIonViewWillEnter } from '@ionic/react';
import { useRepositories } from '../../../infrastructure/http/RepositoryProvider';
import type { Lot } from '../../../domain/Lot';
import type { Site } from '../../../domain/Site';

// Lista de lotes con su estado (etapa, grados día, fecha estimada).
export function useLots() {
  const { lots: lotRepo, sites: siteRepo } = useRepositories();
  const [lots, setLots] = useState<Lot[]>([]);
  const [sites, setSites] = useState<Site[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  // El spinner es solo para la primera carga.
  const loadedRef = useRef(false);

  const load = async () => {
    if (!loadedRef.current) setLoading(true);
    try {
      const [{ lots: list }, siteList] = await Promise.all([
        lotRepo.list(),
        siteRepo
          .list()
          .then((r) => r.sites)
          .catch((): Site[] => []),
      ]);
      setLots(list);
      setSites(siteList);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se pudieron cargar los lotes.');
    } finally {
      loadedRef.current = true;
      setLoading(false);
    }
  };

  useIonViewWillEnter(() => {
    load();
  });

  return { lots, sites, loading, error };
}
